import { Popper } from "../../common/Popper";
import { ClickAwayListener } from "./ClickAwayListener";
import { CommonData } from "../datastructures/gamestate/gameData";
// import { CommonConfig } from "../localization/gameConfig/gameConfigCommonInterface";

export class AutoplayPopper extends Popper{
    private parent:PIXI.Container;
    private autoplayFrameContainer= new PIXI.Container();
    private activeGameData:CommonData;
    private autoplayTitelStake:Array<PIXI.Text>;
    private autoplayTitelStakeButtons:Array<PIXI.Graphics>;
    private autoplayTitelStakeButtonsFrames:Array<PIXI.Graphics>;
    private autoplayCounts:Array<number>;
    private autoplayFrame:PIXI.Sprite;
    private autoplayWindowTweens:Array<PIXI.tween.Tween>;
    private autoSelectFunction:Function;
    private bgTween:PIXI.tween.Tween;
    private isOpen:boolean;

    constructor(parent:PIXI.Container,selectAuto:Function,activeGameData:CommonData)
    {   super(activeGameData)
        this.parent=new PIXI.Container();
        
        this.parent.addChild(this.autoplayFrameContainer);
        this.activeGameData=activeGameData;    
        this.autoSelectFunction=selectAuto;    
        this.autoplayTitelStake=[]
        this.autoplayTitelStakeButtons=[];
        this.autoplayTitelStakeButtonsFrames=[];
       this.setAutoPlayCounts(parent);
      
   
        this.autoplayFrame= new PIXI.Sprite(PIXI.Texture.fromImage("AutoPlayBG.png"));
        this.isOpen=false;
        this.addClickAwayListener(new ClickAwayListener(activeGameData.stage,this.autoplayFrame, this.close.bind(this)));
        
        this.autoplayFrame.anchor.set(.5)
        this.autoplayFrame.x=this.activeGameData.size[0]-this.autoplayFrame.width+10+50;  
        this.autoplayFrame.y=this.activeGameData.size[1]/2+10;
        this.autoplayFrameContainer.addChild(this.autoplayFrame);

        if(activeGameData.isMobile)
        {
            this.autoplayFrame.texture=PIXI.Texture.fromImage("AutoPlayBG.png");
            this.autoplayFrame.scale.set(1.2);
    
            this.autoplayFrame.x=-260
            this.autoplayFrame.y=430
        }
        this.autoplayFrame.interactive=false;
        this.autoplayFrame.on('pointertap', function () {
            // e.preventDefault();
            return false;
        }.bind(this));
        for (var i = 0; i < this.autoplayCounts.length; i++) {
   
            this.autoplayTitelStakeButtons[i] = new PIXI.Graphics();
            
            this.autoplayTitelStakeButtons[i].drawRoundedRect(0,0,160,90,12);
            this.autoplayTitelStakeButtons[i].endFill();
          
            this.autoplayTitelStakeButtonsFrames[i] = new PIXI.Graphics();
             this.autoplayTitelStakeButtonsFrames[i].lineStyle(5,0xffffff,.5) ;
             this.autoplayTitelStakeButtonsFrames[i].beginFill(0x555555,.5);
            this.autoplayTitelStakeButtonsFrames[i].drawRoundedRect(0,0,160,90,12);
            this.autoplayTitelStakeButtonsFrames[i].endFill();
            this.autoplayTitelStakeButtonsFrames[i].alpha=0;
            this.autoplayTitelStakeButtons[i].addChild(this.autoplayTitelStakeButtonsFrames[i])

        
            this.autoplayTitelStake[i]= new PIXI.Text("x "+this.autoplayCounts[i], {fontFamily:activeGameData.gameTextStyle.gameFont, fontWeight:'bold' ,fontSize: 50, fill: "white" ,align:'center', stroke: "#00000055",
                strokeThickness: 15 }            );
    
          


                this.autoplayTitelStake[i].alpha=1;
            this.autoplayTitelStakeButtons[i].buttonMode=false;
            this.autoplayTitelStakeButtons[i].interactive=false;
    
            this.autoplayTitelStakeButtons[i].hitArea=new PIXI.Rectangle(0,0,200,100);
    
            this.autoplayTitelStakeButtons[i].on('pointertap',this.autoSelectFunction.bind(undefined, i,this.activeGameData));
            // this.autoplayTitelStakeButtons[i].on('mouseover', function() { this.alpha=1});
            // this.autoplayTitelStakeButtons[i].on('mouseout', function() { this.alpha=.7 });
            this.autoplayTitelStakeButtons[i].alpha=1;
    
            
            this.autoplayFrameContainer.addChild(this.autoplayTitelStakeButtons[i]);
            this.autoplayTitelStakeButtons[i].addChild(this.autoplayTitelStake[i]);
            this.autoplayTitelStake[i].position.set(this.autoplayTitelStakeButtons[i].width/2-this.autoplayTitelStake[i].width/2,this.autoplayTitelStakeButtons[i].height/2-this.autoplayTitelStake[i].height/2)
            //============
    
    
        }
        this.setVerticalView(false);//default false
        this.createTween()
        this.removeFromCanvas();
        
    
    }
    public setAutoPlayCounts=(parent:PIXI.Container):void=>
    {
        this.autoplayCounts=this.activeGameData.commonConfigData.autoplayList;//configToLoad.autoplayList;

        if( this.autoplayCounts.length>0)
        {
      
         parent.addChild(this.parent);
        }
        else
        {this.autoplayCounts=[0,0,0,0,0];
         }
    }
    public setVerticalView=(bool:boolean):void=>
    {
        
        if(bool)
        {

            //disblay in hotizontalMode only true o#
            // let xSplits=this.activeGameData.size[0]/this.autoplayTitelStakeButtons.length
            this.parent.scale.set(2.5);
            // this.parent.scale.set(1.75);
            let col=0;
            let row=0;
            this.autoplayFrame.alpha=0;
            for (var i = 0; i < this.autoplayTitelStakeButtons.length; i++) {
            //     // this.autoplayTitelStakeButtons[i].updateLineStyle(5,0xffffff,.5)
                this.autoplayTitelStakeButtonsFrames[i].alpha=1;
                if(this.activeGameData.isMobile)
                {  
                    
                    // this.autoplayTitelStakeButtons[i].x=180*col-190; 
                    this.autoplayTitelStakeButtons[i].x= (this.autoplayTitelStakeButtons[i].width+25)*col-30; 
                    this.autoplayTitelStakeButtons[i].y=row*110-100;
                    col++;
                    if(col>2)
                    {   
                        col=0;            
                        row++
                    }
                }
            }
        }
        else
        {
            this.parent.scale.set(1)
            this.autoplayFrame.alpha=1;


            //display in vertical mode (not the screen orientaion)
            for (var i = 0; i < this.autoplayTitelStakeButtons.length; i++) {
                this.autoplayTitelStakeButtonsFrames[i].alpha=0;
                // this.autoplayTitelStakeButtons[i].updateLineStyle(5,0xffffff,0)

                if(this.activeGameData.isMobile)
                {   this.autoplayTitelStakeButtons[i].x=-340   
                    this.autoplayTitelStakeButtons[i].y=110*(i%6)+115;
                }
                else
                {     
                    this.autoplayTitelStakeButtons[i].x=this.activeGameData.size[0]-this.autoplayTitelStakeButtons[i].width-40-135+32;   
                    this.autoplayTitelStakeButtons[i].y=95*(i%6)+200+65;
    
                }
            }
            
         

        }
    }
    public setNewPos=(newPos:Array<number>):void=>
    {
        this.parent.position.set(newPos[0],newPos[1])
    }
    private createTween=():void=>
    { 
    
        this.autoplayWindowTweens=[];
        for (var i = 0; i < this.autoplayTitelStakeButtons.length; i++) {

            this.autoplayWindowTweens[i]= PIXI.tweenManager.createTween(this.autoplayTitelStakeButtons[i]);   
            if(this.activeGameData.isMobile)
            {
                this.autoplayWindowTweens[i].from({x:this.autoplayTitelStakeButtons[i].x+90,alpha:0}).to({x:this.autoplayTitelStakeButtons[i].x,alpha:1});
            
            }   
            else{   
            this.autoplayWindowTweens[i].from({y:this.autoplayTitelStakeButtons[i].y+90,alpha:0}).to({y:this.autoplayTitelStakeButtons[i].y,alpha:1});
            }
            this.autoplayWindowTweens[i].time =0+i*50;
            // this.autoplayWindowTweens[i].delay=i*20;
            this.autoplayWindowTweens[i].easing = PIXI.tween.Easing.outBack();
      
            this.autoplayWindowTweens[i].stop();
        }

        
        this.bgTween= PIXI.tweenManager.createTween(this.autoplayFrame);  
        if(this.activeGameData.isMobile)
        {
            this.bgTween.from({x:this.autoplayFrame.x+90,alpha:0}).to({x:this.autoplayFrame.x,alpha:1});
        
        }   
        else{   
        this.bgTween.from({y:this.autoplayFrame.y+90,alpha:0}).to({y:this.autoplayFrame.y,alpha:1});
        }
        this.bgTween.time =0+i*50;
        // this.autoplayWindowTweens[i].delay=i*20;
        this.bgTween.easing = PIXI.tween.Easing.outBack();
  
        this.bgTween.stop(); 
        
    }
    private autoSelectable=(bool:boolean):void=>
    {   
        // this.activeGameData.sound.play('btnClick');
     
        if(bool){
            this.parent.alpha=1;
            // this.playTween();
        }
        else{
            this.parent.alpha=0;
        }
        for (var i = 0; i < this.autoplayTitelStakeButtons.length; i++) {
            this.autoplayTitelStakeButtons[i].buttonMode=bool;
            this.autoplayTitelStakeButtons[i].interactive=bool;
            if(bool===false)
            {
                // this.autoplayTitelStakeButtons[i].alpha=0;
            }
            
        }

    }
    public onClick=():void=>
    {   
    //   console.log("CLICKED")
        // if(this.activeGameData.activePlaying===false)
        // {     
            if(this.parent.alpha===0)
            {
                
                this.autoSelectable(true);
                this.open();
                this.isOpen=true;
                this.activeGameData.gameBar.hidePlayOnPortrait(true);
                this.autoplayFrame.interactive=true;
                // console.log('HIDE')
               
            }
            else
            {
                // this.autoSelectable(false);
                this.close();
                this.autoplayFrame.interactive=false;
                this.isOpen=false;
                this.activeGameData.gameBar.hidePlayOnPortrait(false)
                // console.log('SHOW')
            }

            


          
        // }
    }
    
    public removeFromCanvas()
    {
        this.autoplayFrame.interactive=false;
        this.autoSelectable(false);
        this.isOpen=false;
        this.activeGameData.gameBar.hidePlayOnPortrait(false)
        // console.log('SHOW PLAyBTN')
    }


    public getIsOpen=():boolean=>
    {
        return this.isOpen;
    }
  

    // private playTween=():void=>
    // {
    //     for (var i = 0; i < this.autoplayTitelStakeButtons.length; i++) {
    //         this.autoplayWindowTweens[i].reset();
    //         this.autoplayWindowTweens[i].start();
            
    //     }

    //     this.bgTween.reset();
    //     this.bgTween.start();
    // }

    public getAutoPlayCountSelected=(index:number):number=>
    {
       return  this.autoplayCounts[index];
    }


    public setDestopTexture=():void=>
    {
        this.autoplayFrame.texture= PIXI.Texture.fromImage("AutoPlayBG.png");
    }
    public getFrame=():PIXI.Sprite=>
    {
        return this.autoplayFrame;
    }

    public getParent=():PIXI.Container=>
    {
        return this.autoplayFrameContainer;
    }
    // public getAutoPlayFrameAndNumbersPArent=():PIXI.Container=>
    // {
    //     return this.autoplayFrameContainer;
    // }
}
      
